import React, { useEffect, useState, } from 'react';
import { ColorTokens, FontFamilyTokens, FontSizeTokens, IconSizeTokens, IconTokens, TypographyTypeDLS, } from '@voltmoney/schema';
import { Dimensions, Platform, View, } from 'react-native';
import { Typography } from '../../typography/Typography';
import { Icon } from '../../icon/Icon';
import { isMobileView } from '../../stack/utils';
import { addCommasToNumber } from '../utils';
import LottieView from 'lottie-react-native';
const MFCentralFetchLanding = ({ windowHeight, availableCreditAmount, isFromEnhanceLimit, }) => {
    const [lottieKey, setLottieKey] = useState(0);
    useEffect(() => {
        setLottieKey(lottieKey + 1);
    }, []);
    const congratulationsCard = () => {
        return (React.createElement(View, { style: {
                borderRadius: 24,
                paddingHorizontal: 16,
                paddingVertical: 32,
                marginBottom: 40,
                backgroundColor: '#fff',
                alignItems: 'center',
                alignContent: 'center',
                position: 'absolute',
                zIndex: 1,
                width: isMobileView()
                    ? Dimensions.get('window').width - 64
                    : 444,
            } },
            React.createElement(Icon, { name: IconTokens.FETCH_SUCCESS }),
            React.createElement(View, { style: { marginTop: 40, marginBottom: 4 } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.H1B, label: 'Congratulations!', color: ColorTokens.Grey_Night })),
            React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1R, label: isFromEnhanceLimit
                    ? 'You are eligible for an additional limit of'
                    : 'Your eligible limit is', color: ColorTokens.Grey_Charcoal }),
            React.createElement(View, { style: {
                    marginTop: 12,
                    flexDirection: 'row',
                } },
                React.createElement(View, { style: {
                        marginTop: Platform.OS !== 'web' ? 0 : 4,
                    } },
                    React.createElement(Typography, { fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.XXXXL, fontWeight: '700', label: '₹', color: ColorTokens.Secondary_100 })),
                React.createElement(Typography, { fontFamily: FontFamilyTokens.Poppins, fontSize: FontSizeTokens.XXXXL, fontWeight: '700', label: `${addCommasToNumber(availableCreditAmount)}`, color: ColorTokens.Secondary_100 }))));
    };
    const confettiLottie = () => {
        return (React.createElement(View, { style: {
                position: 'absolute',
                zIndex: 2,
                height: '100%',
                width: '100%',
                justifyContent: 'center',
                alignItems: 'center',
                alignContent: 'center',
                alignSelf: 'center',
            } }, Platform.OS === 'ios' ? (React.createElement(LottieView, { source: {
                uri: 'https://lottie.host/fdf0ed27-a8a9-443a-9bb6-4163bb1aa45e/2dGBozmqhI.json',
            }, loop: true, key: lottieKey, autoPlay: true })) : (React.createElement(LottieView, { source: require('../../lottie/assets/fall-from-the-sky.json'), loop: true, autoPlay: true }))));
    };
    return (React.createElement(View, { style: {
            width: '100%',
            alignContent: 'center',
            justifyContent: 'center',
            alignItems: 'center',
            alignSelf: 'center',
            paddingHorizontal: -16,
            height: windowHeight - 56,
            marginBottom: 40,
        } },
        React.createElement(View, { style: {
                alignContent: 'center',
                justifyContent: 'center',
                alignItems: 'center',
            } },
            confettiLottie(),
            congratulationsCard(),
            React.createElement(View, { style: { marginBottom: 40 } },
                React.createElement(Icon, { name: IconTokens.FETCH_SUCCESS_IMAGE, size: IconSizeTokens.SIZE_WEB_FULL })))));
};
export default MFCentralFetchLanding;
